declare global {
  interface Window {
    dataLayer: any[];
  }
}

/**
 * Initialize Google Tag Manager
 * @param gtmId - The GTM container ID (e.g., 'GTM-XXXXXXX')
 */
export const initGTM = (gtmId: string): void => {
  if (!gtmId) {
    console.warn("GTM ID is not provided. Skipping GTM initialization.");
    return;
  }

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  // Load GTM script
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;

  const firstScript = document.getElementsByTagName("script")[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }

  // Add GTM noscript iframe
  const noscript = document.createElement("noscript");
  const iframe = document.createElement("iframe");
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = "0";
  iframe.width = "0";
  iframe.style.display = "none";
  iframe.style.visibility = "hidden";
  noscript.appendChild(iframe);

  if (document.body.firstChild) {
    document.body.insertBefore(noscript, document.body.firstChild);
  } else {
    document.body.appendChild(noscript);
  }
};

/**
 * Check if GTM should be enabled based on environment variables
 * @returns True if GTM is enabled, false otherwise
 */
export const isGTMEnabled = (): boolean => {
  const gtmId = process.env.GTM_ID;
  return !!gtmId;
};

/**
 * Get GTM ID from environment variables
 * @returns The GTM ID or null if not set
 */
export const getGTMId = (): string | null => {
  return process.env.GTM_ID || null;
};

/**
 * Initialize GTM if enabled in the environment
 */
export const initGTMIfEnabled = (): void => {
  const gtmId = getGTMId();
  if (gtmId) {
    initGTM(gtmId);
  } else {
    console.log("GTM is disabled (GTM_ID not set).");
  }
};
